import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const PostTradeWorkspaceLazy = lazyWithRetry(() => import('./PostTradeWorkspace'));

export function PostTradeWorkspaceRoute() {
  return (
    <Suspense fallback={<LazyFallback />}>
      <PostTradeWorkspaceLazy />
    </Suspense>
  );
}
